export const INTERNAL_PATHS = {
  PROJECT_SCHEDULE: '/internal/project-schedule',
  TRANSLATIONS_EDITOR: '/internal/TranslationsEditor',
  PROGRAM_MANAGER_APPLICATION_LIST: '/internal/ProgramManagerApplicationList',
  CONTRACT: '/internal/contract',
  BUDGET_WIDGET: '/internal/widgets/budget',
  EXPORT_SURVEYS: '/internal/ExportSurveys',
  CREATE_FORM_PREVIEW_URL: '/internal/create-form-preview-url',
  FUNDING_STREAMS_EDITOR: '/internal/funding-streams-editor',
  PORTAL_CONFIGURATIONS: '/internal/PortalConfigurations',
  CONFIGURE_USER_PERMISSIONS: '/internal/ConfigureUserPermissions',
  PAGE_TRANSLATIONS: '/internal/page-translations',
  EXPORT_IMPORT_OBJECTS: '/internal/ExportImportObjects',
  ACTIVE_SESSIONS: '/internal/active-sessions',
  GENERATE_PDF_FOR_APPLICATION: '/internal/generate-pdf-for-application',
  FORMS: '/internal/forms'
} as const
